import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import MoneyOffCsredIcon from '@mui/icons-material/MoneyOffCsred';
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import MasksIcon from '@mui/icons-material/Masks';
import ElderlyWomanIcon from '@mui/icons-material/ElderlyWoman';
import SchoolIcon from '@mui/icons-material/School';
import SickIcon from '@mui/icons-material/Sick';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import WorkIcon from '@mui/icons-material/Work';
import CelebrationIcon from '@mui/icons-material/Celebration';
import BusinessIcon from '@mui/icons-material/Business';

export const timeTypeMap = {
  worked: { label: 'Workday', color: 'info', Icon: WorkIcon },
  holiday: {
    label: 'Holiday',
    color: 'success',
    Icon: CelebrationIcon,
  },
  vacation: {
    label: 'Vacation',
    color: 'success',
    Icon: BeachAccessIcon,
  },
  sick: { label: 'Sick', color: 'error', Icon: SickIcon },
  mixed: {
    label: 'Mixed',
    color: 'info',
    Icon: DashboardCustomizeIcon,
  },
  unpaidVacation: {
    label: 'Unpaid vacation',
    color: 'error',
    Icon: MoneyOffCsredIcon,
  },
  maternityLeave: {
    label: 'Maternity leave',
    color: 'warning',
    Icon: PregnantWomanIcon,
  },
  paternityLeave: {
    label: 'Paternity leave',
    color: 'warning',
    Icon: BabyChangingStationIcon,
  },
  parentalLeave: {
    label: 'Parental leave',
    color: 'warning',
    Icon: FamilyRestroomIcon,
  },
  childSickLeave: {
    label: 'Child sick leave',
    color: 'warning',
    Icon: MasksIcon,
  },
  careLeave: {
    label: 'Care leave',
    color: 'warning',
    Icon: ElderlyWomanIcon,
  },
  educationalLeave: {
    label: 'Educational leave',
    color: 'warning',
    Icon: SchoolIcon,
  },
  timeCompensation: {
    label: 'Time Compensation',
    color: 'success',
    Icon: HistoryToggleOffIcon,
  },
  companyHoliday: {
    label: 'Company Holiday',
    color: 'success',
    Icon: BusinessIcon,
  },
};
